import createEventEmitter from 'util/createEventEmitter';

export const breakpoints = {
  DESKTOP: 1060,
  DRAWER: 641,
};

export const media = {
  DESKTOP_OR_MORE: `screen and (min-width: ${breakpoints.DESKTOP}px)`,
  LESS_THAN_DESKTOP: `screen and (max-width: ${breakpoints.DESKTOP - 0.1}px)`,
  TABLET_OR_MORE: `screen and (min-width: ${breakpoints.DRAWER}px)`,
  LESS_THAN_TABLET: `screen and (max-width: ${breakpoints.DRAWER - 0.1}px)`,
};

export const closeHeaderEmitter = createEventEmitter<void>();
